import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './providers.scss';
import React from 'react';
import { T } from 'shared/helper/translate';
import { parseQueryParams } from 'shared/helper/link-helper';
import { getApiBaseUrl } from 'shared/helper/request';
import WeChatLogin from './WeChatLogin';
var Providers = function Providers(_ref) {
  var _parseQueryParams$ori;
  var providers = _ref.providers,
    referringUrl = _ref.referringUrl;
  if (providers.length === 0) {
    return null;
  }
  var origin = (_parseQueryParams$ori = parseQueryParams(window.location.search).origin) !== null && _parseQueryParams$ori !== void 0 ? _parseQueryParams$ori : '';
  var params = "?redirect=".concat(referringUrl && referringUrl.startsWith('http') ? referringUrl : window.location.origin + (referringUrl || '/'));
  params = origin ? params.concat(params.length > 0 ? '&' : '?', "origin=".concat(origin)) : params;
  return /*#__PURE__*/React.createElement("div", {
    className: "row providers"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-6 offset-md-3"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Log in with your social account"
  })), /*#__PURE__*/React.createElement("ul", {
    className: "list-unstyled list-inline d-block mb-1"
  }, providers.map(function (provider) {
    return /*#__PURE__*/React.createElement("li", {
      key: provider.id,
      className: "d-inline-block m-2 p-0"
    }, /*#__PURE__*/React.createElement("a", {
      className: "btn btn-primary btn-squared",
      href: "".concat(getApiBaseUrl(), "/api/auth/opa/").concat(provider.id).concat(params)
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: "".concat(provider.icon),
      role: "button"
    }), /*#__PURE__*/React.createElement("span", {
      className: "provider-icon-spacer"
    }), provider.name));
  }), /*#__PURE__*/React.createElement(WeChatLogin, null))));
};
export default Providers;